window.addEventListener("beforeunload", function () {
  document.body.classList.add("animate-out");
});

/* If the browser restores this page from its back-forward cache (bfcache)
   instead of doing a fresh load -- which commonly happens when hitting the
   Back button -- it comes back exactly as it looked the instant the user
   left, including the "animate-out" class above having already faded the
   whole page to invisible. Since that fade uses animation-fill-mode:
   forwards, it stays invisible permanently (a black/blank screen) until a
   real reload resets it. Removing the class the moment the page comes back
   from cache (pageshow with event.persisted true means exactly that) fixes
   it instantly, with no refresh needed. */
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    document.body.classList.remove("animate-out");
  }
});